"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12c0-2.468.749-4.764 2.031-6.673a.501.501 0 0 1 .142-.206C4.345 2.026 7.94 0 12 0Zm.339 18.017-5.017.456-1.359 2.719A10.937 10.937 0 0 0 12 23c.875 0 1.726-.103 2.542-.297l.417-2.503-2.62-2.183Zm8.876-.016L19.645 18l-3.69 2.307-.347 2.085a11.055 11.055 0 0 0 5.404-4.091l.203-.3ZM4.23 14.043l-2.951.423a11.02 11.02 0 0 0 3.864 6.13l1.292-2.584-2.205-3.969Zm14.323-.996-4.18.418-1.291 3.869 2.46 2.05 3.43-2.144-.419-4.193Zm-7.779-3.516-3.477.435-2.217 3.548 2.199 3.959 4.85-.441 1.314-3.942-2.669-3.559Zm10.045-.457-1.31 3.494.443 4.432h1.844A10.933 10.933 0 0 0 23 12c0-.877-.103-1.73-.298-2.55l-1.883-.376ZM1 12c0 .502.034.997.1 1.482l3.097-.444 2.24-3.582-1.289-3.008-2.396-.399A10.936 10.936 0 0 0 1 12Zm16.739-6.972-4.415.442-1.739 3.477 2.646 3.528 4.41-.441 1.304-3.477-2.206-3.529ZM9.537 3.597 6.114 6.164l1.197 2.793 3.361-.42 1.669-3.338-2.804-1.602Zm8.964-.465L18.5 4.356l2.31 3.696 1.574.315A11.052 11.052 0 0 0 18.5 3.132ZM3.403 5.145l1.967.327L9 2.749V1.416a11.025 11.025 0 0 0-5.356 3.438l-.24.29ZM12 1c-.683 0-1.351.063-2 .182V2.71l3.109 1.776 4.391-.439V2.5l.003-.022C15.883 1.538 14.003 1 12 1Z",
    clipRule: "evenodd"
  })]
});